import React, { useEffect, useMemo, useState } from "react";
import { Alert, Grid } from "@mui/material";
import { Navigate } from "react-router-dom";

import DistributionReviewApi from "../../../infrastructure/api/distributionReview";
import useGetPageInfo from "../../common/hooks/useGetPageInfo";
import Dashboard from "../../components/dashboard";
import { canAccessDistributionPortal } from "../../utils/authRoleHelpers";
import { getSelectedDistributionCompanyId } from "./DistributionCompanySelect";
import EDCBreadcrumbs, { EDC_ROOT_CRUMB } from "./EDCBreadcrumbs";
import { EDC_PATHS, REQUEST_UNITS } from "./edcPaths";

const pick = (obj, ...keys) => {
  for (const k of keys) {
    if (obj?.[k] != null) return obj[k];
  }
  return undefined;
};

const buildFallbackTiles = (context) => {
  const isCompanyAdmin = pick(context, "isCompanyAdmin", "IsCompanyAdmin") === true;
  const canArea =
    isCompanyAdmin || pick(context, "canAreaReview", "CanAreaReview") === true;
  const canEngineering =
    isCompanyAdmin ||
    pick(context, "canEngineeringReview", "CanEngineeringReview") === true;

  const tiles = [];
  if (isCompanyAdmin) {
    tiles.push({
      title: "مدیریت",
      link: EDC_PATHS.management,
      icon: "chart",
      description: "داشبورد مدیریت شرکت توزیع",
    });
    tiles.push({
      title: "کاربران",
      link: EDC_PATHS.users,
      icon: "UM",
      description: "کاربران امورها و دسترسی‌ها",
    });
  }
  if (canArea)
    tiles.push({
      title: REQUEST_UNITS.area.title,
      link: REQUEST_UNITS.area.basePath,
      icon: "user",
      description: "داشبورد و کارتابل امورهای شما",
    });
  if (canEngineering)
    tiles.push({
      title: REQUEST_UNITS.engineering.title,
      link: REQUEST_UNITS.engineering.basePath,
      icon: "diagram",
      description: "امکان‌سنجی و طرح اولیه",
    });
  return tiles;
};

const EDCPage = () => {
  const pageInfo = useGetPageInfo();
  const menuChildren = Array.isArray(pageInfo?.child) ? pageInfo.child : [];
  const hasMenu = menuChildren.length > 0;

  const [context, setContext] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasMenu) return undefined;
    let cancelled = false;
    DistributionReviewApi.getPortalContext(getSelectedDistributionCompanyId())
      .then((res) => {
        if (!cancelled) setContext(res?.data ?? res?.Data ?? null);
      })
      .catch((e) => {
        if (!cancelled) setError(e?.message || "خطا در دریافت دسترسی های شرکت توزیع");
      });
    return () => {
      cancelled = true;
    };
  }, [hasMenu]);

  const fallbackTiles = useMemo(() => buildFallbackTiles(context), [context]);

  if (!canAccessDistributionPortal()) return <Navigate to="/403" replace />;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <EDCBreadcrumbs crumbs={[EDC_ROOT_CRUMB]} />
      </Grid>

      {error ? (
        <Grid item xs={12}>
          <Alert severity="error">{error}</Alert>
        </Grid>
      ) : null}

      <Grid item xs={12} md={12}>
        {hasMenu ? (
          <Dashboard menuList={menuChildren} cartTitle={pageInfo.title} />
        ) : (
          <Dashboard menuList={fallbackTiles} cartTitle={EDC_ROOT_CRUMB.title} />
        )}
      </Grid>
    </Grid>
  );
};

export default EDCPage;
